export function getEmbedUrlDetailUrl(id: string): string {
  return `/api/share-links/${id}`;
}

export function getEmbedUrlPageUrl(id: string): string {
  return `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}/s/${id}/`;
}

export function getEmbedUrlIframeSrc(id: string): string {
  return `${getEmbedUrlPageUrl(id)}embed/`;
}

export function getEmbedUrloEmbedUrl(id: string): string {
  const embedUrlPageUrl = encodeURIComponent(getEmbedUrlPageUrl(id));
  const url = `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}/api/oembed`;
  return `${url}?url=${embedUrlPageUrl}&format=json`;
}

export function getEmbedUrlIsActiveUrl(id: string): string {
  return `/api/share-links/${id}/is-active`;
}
